<template>
  <div class="faq container fluid">
    <div class="faq__nav row">
      <router-link class="faq__nav__back" to="/shoes">
        <img src="@/assets/images/ic_back.svg" />
      </router-link>
      <Logo class="faq__nav__logo" color />
    </div>
    <div class="faq__header row">
      <div class="col-xs-8">
        <h2>Comment pouvons nous vous aider ?</h2>
        <p>
          Notre team est ici pour vous aider. Retrouvez ci-dessous les questions
          les plus fréquentes posées par nos membres.
        </p>
      </div>
      <span><img src="@/assets/images/form-o-1.svg" alt="o"/></span>
      <span><img src="@/assets/images/form-o-2.svg" alt="o"/></span>
      <span><img src="@/assets/images/form-r-1.svg" alt="☐"/></span>
      <span><img src="@/assets/images/form-r-2.svg" alt="☐"/></span>
      <span><img src="@/assets/images/form-t-1.svg" alt="△"/></span>
      <span><img src="@/assets/images/form-t-2.svg" alt="△"/></span>
      <span><img src="@/assets/images/form-x-2.svg" alt="x"/></span>
      <span><img src="@/assets/images/form-x-3.svg" alt="x"/></span>
    </div>
    <div class="faq__content row">
      <div class="col-xs-11 col-md-8">
        <h3>Le concept</h3>
        <FaqQuestionItem
          v-for="(item, i) in questions[0].values"
          :key="item.family + i"
          :num="`${i + 1}`"
          :ask="item.ask"
          :answer="item.answer"
        />
        <h3>Livraison et échanges</h3>
        <FaqQuestionItem
          v-for="(item, i) in questions[1].values"
          :key="item.family + i"
          :num="`${i + 1}`"
          :ask="item.ask"
          :answer="item.answer"
        />
        <h3>Nettoyage et Assurance</h3>
        <FaqQuestionItem
          v-for="(item, i) in questions[2].values"
          :key="item.family + i"
          :num="`${i + 1}`"
          :ask="item.ask"
          :answer="item.answer"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Logo from "@/components/Common/Logo";
import FaqQuestionItem from "@/components/Faq/FaqQuestionItem";
export default {
  name: "Faq",
  components: {
    Logo,
    FaqQuestionItem
  },
  computed: {
    ...mapState({
      questions: state => state.faq
    })
  }
};
</script>

<style lang="scss">
.faq {
  &__nav {
    position: relative;
    justify-content: center;
    align-items: center;
    font-size: 1.6rem;
    padding: 2rem;
    img {
      height: 1.5rem;
      margin-right: 1rem;
    }
    &__back {
      display: flex;
      align-items: center;
      position: absolute;
      left: 2rem;
    }
  }
  &__header {
    position: relative;
    justify-content: center;
    text-align: center;
    background: get($colors, "light-green");
    padding: 8rem 0;
    overflow: hidden;
    h2 {
      font-size: 2rem;
      font-weight: bold;
      margin-bottom: 1em;
    }
    p {
      color: get($colors, "grey");
    }
    > span {
      position: absolute;
      display: inline-block;
      animation: bounce infinite ease-in-out alternate;
      @for $i from 0 through 10 {
        &:nth-of-type(#{$i}) {
          animation-duration: random(10) + s;
          animation-delay: random(10) + s;
          top: random(90) * 1%;
          left: $i * 10 * 1%;
        }
      }
    }
  }
  &__content {
    justify-content: center;
    padding: 5rem 0;
    h3 {
      font-size: 2rem;
      font-weight: bold;
      margin-bottom: 1em;
      margin-top: 6.5rem;
      &:first-child {
        margin-top: 0;
      }
    }
  }
}
</style>
